import type { useDataservice } from "~/composables/useDataservice"

/**
 * Runs `fn` once the dataservice has been initialised.
 *
 * Plugins register at Nuxt app-creation time — BEFORE bootstrap calls
 * `useDataservice().init()` (see stores/bootstrap.ts). The entity getters
 * (`activities`, `openMenu`, `voidItems`, ...) are `null` until `init()` wires
 * them up, so calling them at plugin load throws
 * `Cannot read properties of null`. This defers `fn` until `isInited` flips
 * true, then fires exactly once. If the dataservice is already inited, runs
 * immediately.
 */
export const onDataserviceReady = (
  dataservice: ReturnType<typeof useDataservice>,
  fn: () => void,
) => {
  if (dataservice.isInited.value) {
    fn()
    return
  }
  const stop = watch(
    () => dataservice.isInited.value,
    (ready) => {
      if (!ready) return
      stop()
      fn()
    },
  )
}
